
import React, { useState, useEffect } from "react";
import { Dialog } from 'primereact/dialog';
import '../../scss/Navmenudetail.scss'


export default function NavInfo(props) {
    const { visible, onClose, type } = props;
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const renderTitle = () => {
        if (type == "NGUPHAP") {
            return "Grammar and Vocabulary";
        }
        else if (type == "NGHE") {
            return "Listening";
        }
        else if (type == "DOC") {
            return "Reading";
        }
        else if (type == "VIET") {
            return "Writing";
        }
        else {
            return "Speaking";
        }
    }
    const footerContent = (
        <div>
            {/* <Button label="No" icon="pi pi-times" onClick={() => setVisible(false)} className="p-button-text" />
            <Button label="Yes" icon="pi pi-check" onClick={() => setVisible(false)} autoFocus /> */}
        </div>
    );
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);
    return (
        <div className="card">
            <Dialog footer={footerContent} header="Information" visible={visible} position='top-left' style={{
                width: isMobile ? '80vw' : '20vw',
                height: '80vh'
            }} onHide={() => onClose()} draggable={false} resizable={false}>
                <div className="mt-4" style={{ borderStyle: "dotted", borderColor: "#3333", borderRadius: '8px', margin: "10px", padding: '6px', borderWidth: '2px' }}>
                    <div className=" d-flex" >
                        <div style={{ padding: '4px', width: '85%' }}>
                            <div style={{ fontWeight: '500' }}>
                                {renderTitle()}
                            </div>
                        </div>
                    </div>

                </div>

                <div className="mt-4" style={{ borderStyle: "dotted", borderColor: "#3333", borderRadius: '8px', margin: "10px", padding: '6px', borderWidth: '2px' }}>
                    <div style={{ width: '85%' }}>
                        <div style={{ fontWeight: '500' }}>
                            Description
                        </div>
                    </div>
                    <div style={{ width: '85%' }}>
                        <div style={{ fontWeight: '500' }}>
                            Aptis General Practice Test
                        </div>
                    </div>

                </div>

            </Dialog>
        </div>
    )
}
